export const buildFilters = (query, filterConfig) => {
    return filterConfig.reduce((accum, curr) => {
        const values = {};
        curr.filterKeys.forEach((filterKey) => {
            if (query.hasOwnProperty(filterKey) && query[filterKey] !== '') {
                values[filterKey] = query[filterKey];
            }
        });
        if (Object.keys(values).length > 0) {
            accum.push({
                stateKey: curr.stateKey,
                comparator: curr.comparator,
                filterValues: values
            });
        }
        return accum;
    }, []);
};
export const filterData = (data, filters) => {
    return data.filter((item) => {
        return filters.every(({ filterValues, comparator }) => {
            return comparator(item, filterValues);
        });
    });
};
